<p-checkbox
  (ngModelChange)="handleSelectionChange($event)"
  [binary]="true"
  [ngModel]="isChecked$ | async" />
